module.exports = __webpack_public_path__ + "files/35fb1afdcfe577bdac26bd1042462bf0.png";